import { getFullNameForPersonnel } from '@esentai/core/features/users/selectors';
import { connect } from 'react-redux';

import Option from '@/components/AutocompleteBase/Option';

const mapStateToProps = (state, { value }) => ({
  label: getFullNameForPersonnel(state, value),
});

export default connect(mapStateToProps, () => ({}))(Option);
